<div class="RF">
    <div class="RF__header">
        <img class="RF__header-img" src="../../../../resources/images/play.png" alt="">
        <div class="RF__header-heading">Monjin Platform</div>
        <div class="RF__header-sub">Please register with your work address</div>
    </div>

    <form class="RF__content" @submit.prevent="onSubmit">

        <input-container :dirtyForm="$v.$dirty || ifEmailExists">
            <div class="RF__label">Work email</div>
            <div class="RF__email">
                <text-field class="input-field" :error="hasError('email') || ifEmailExists"
                    v-model.trim="email" @blur="checkEmailAvailability"></text-field>
                <progress-spinner class="RF__spinner" v-if="checking"></progress-spinner>
                <mom-icon class="RF__available" width="24" height="24"
                    svgIcon="checked-circle" v-else-if="checkDone && !ifEmailExists"></mom-icon>
                <mom-icon class="RF__unavailable" width="24" height="24"
                    svgIcon="cross-circle" v-else-if="checkDone && ifEmailExists"></mom-icon>
            </div>
            <mom-error v-if="!$v.email.required">Email is required.</mom-error>
            <mom-error v-else-if="!$v.email.email">Please enter a valid email.</mom-error>
            <mom-error v-else-if="!$v.email.isPrivateEmail">Please use only organizational email.</mom-error>
            <mom-error v-else-if="ifEmailExists">Email already registered.</mom-error>
        </input-container>

        <input-container :dirtyForm="$v.$dirty">
            <div class="RF__label">Password</div>
            <div class="RF__password-hint">
                <text-field :type="passwordFieldType" class="input-field" :error="hasError('password')"
                    v-model="password" @paste="disablePaste" @blur="checkPasswordStrength(false)"></text-field>
                <mom-icon class="RF__view-icon" width="24" height="24"
                    svgIcon="view" @click.native="switchVisiblity('password')"></mom-icon>
                <mom-popper trigger="click" ref="popper" :arrow="false">
                    <div class="RF__password-tips m-panel">
                        <strong>Password must include</strong>
                        <ul class="RF__password-tip-list">
                            <li v-for="hint in passwordHints" :class="hint.satisfied ? 'satisfied' : ''">
                                <span>{{ hint.text }}</span>
                            </li>
                        </ul>
                    </div>
                    <mom-icon slot="anchor" class="RF__bulb-icon" width="24" height="24"
                        :key="passwordHint" svgIcon="light-bulb"></mom-icon>
                </mom-popper>
            </div>
            <mom-error v-if="!$v.password.required">Password is required.</mom-error>
        </input-container>

        <input-container :dirtyForm="$v.$dirty">
            <div class="RF__label">Confirm Password</div>
            <div class="RF__confirm-password">
                <text-field :type="confirmPasswordFieldType" class="input-field" :error="hasError('password2')"
                    v-model="password2" @paste="disablePaste"></text-field>
                <mom-icon class="RF__confirm-view-icon" width="24" height="24"
                    svgIcon="view" @click.native="switchVisiblity('confirmPassword')"></mom-icon>
            </div>
            <mom-error v-if="!$v.password2.sameAs">Passwords must match.</mom-error>
        </input-container>

        <div class="RF__proceed">
            <mom-button type="submit" variant="raised">Next</mom-button>
        </div>

        <div class="RF__signIn">
            <span>Already have an account?</span> <a href="/internal/auth/server">Sign in</a>
        </div>
    </form>
</div>
